import { render, staticRenderFns } from "./CancelHistory.vue?vue&type=template&id=a1feff50&scoped=true&"
import script from "./CancelHistory.vue?vue&type=script&lang=js&"
export * from "./CancelHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1feff50",
  null
  
)

export default component.exports